import { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import logo from '../assets/logo.png';
import '../styles/Header.css';

const hasPermission = (user, code) => {
  if (!user?.quyenHanhDong) return false;
  return user.quyenHanhDong.split(',').map(s => s.trim()).includes(String(code));
};

const Header = ({ title }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const displayName = user?.hoVaTen || user?.name || user?.username || '';
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLogout = () => {
    setMenuOpen(false);
    logout();
    navigate('/login');
  };

  return (
    <header className="app-header">
      <div className="header-left">
        <div className="logo-mini">
          <img src={logo} alt="Logo" />
        </div>
        <div className="header-title">
          <h1>{title}</h1>
          <span className="header-subtitle">{process.env.REACT_APP_HOSPITAL_NAME || 'Hùng Vương Gia Lai'}</span>
        </div>
      </div>
      <div className="header-right">
        <div className="header-menu" ref={menuRef}>
          <button
            className="header-menu-trigger"
            onClick={() => setMenuOpen((prev) => !prev)}
          >
            <span className="user-avatar">
              {displayName ? displayName.charAt(0).toUpperCase() : ''}
            </span>
            <span className="user-name hide-mobile">{displayName}</span>
            <svg className="menu-chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="16" height="16">
              <polyline points="6 9 12 15 18 9" />
            </svg>
          </button>

          {menuOpen && (
            <div className="header-dropdown">
              {hasPermission(user, '1') && (
                <button className="dropdown-item" onClick={() => { setMenuOpen(false); navigate('/ho-so'); }}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                    <circle cx="12" cy="7" r="4" />
                  </svg>
                  Quản Lý Hồ Sơ
                </button>
              )}
              <div className="dropdown-divider" />
              <button className="dropdown-item dropdown-item-danger" onClick={handleLogout}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                  <polyline points="16 17 21 12 16 7" />
                  <line x1="21" y1="12" x2="9" y2="12" />
                </svg>
                Đăng xuất
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
